import { rtkApi } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import { ICertificatesResponse, ICertificateDetailResponse } from './types';

const certificatesApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getCertificates: build.query<ICertificatesResponse, void>({
      query: () => '/student/my-profile/certificates',
      transformResponse: (
        response: SuccessApiResponse<ICertificatesResponse>,
      ): ICertificatesResponse => response.data,
    }),
    getCertificateById: build.query<ICertificateDetailResponse, string>({
      query: (certificateId) => `/student/my-profile/certificates/${certificateId}`,
      transformResponse: (
        response: SuccessApiResponse<ICertificateDetailResponse>,
      ): ICertificateDetailResponse => response.data,
    }),
  }),
});

export const { useGetCertificatesQuery, useGetCertificateByIdQuery } = certificatesApi;
